<app-landing-header></app-landing-header>

<div class="landing-header-spacer" [class.with-subnav]="hasProductSubnav()"></div>

<div class="landing-content">
  <ng-container *ngIf="isRootPath() || isEmailVerify(); else otherRoutes">
    <app-landing-home></app-landing-home>
  </ng-container>
  <ng-template #otherRoutes>
    <router-outlet></router-outlet>
  </ng-template>
</div>

<app-landing-footer></app-landing-footer>
